import { Box, CircularProgress, Typography, alpha } from '@mui/material';
import { type ReactNode, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAccount } from 'wagmi';

import BasicTabs from 'src/components/BasicTabs';
import { EditNodeSaleForm } from 'src/components/NodeSaleForm/EditNodeSaleForm';
import OtcSales from 'src/pages/otc-sales';
import { DeploymentProvider } from 'src/provider/DeploymentProvider';
import { ThemeCustomizationProvider } from 'src/provider/ThemeCustomizationProvider';
import { useGetProjectDetailQuery } from 'src/store/services/project.service';

type TabItem = {
  label: string;
  content: ReactNode;
  key: string;
};

const DetailsNodeSale = () => {
  const { id } = useParams();
  const { address } = useAccount();
  const { data, isLoading } = useGetProjectDetailQuery(
    { id, address },
    {
      skip: !id || !address,
    },
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [tab, setTab] = useState<string>('0');

  const TABS_DATA = [
    {
      label: 'General Sales',
      content: (
        <DeploymentProvider initialHasDeployed={false}>
          <ThemeCustomizationProvider>
            <EditNodeSaleForm defaultValues={data} isDetail />
          </ThemeCustomizationProvider>
        </DeploymentProvider>
      ),
      key: '0',
    },
    {
      label: 'OTC Sales',
      content: <OtcSales />,
      key: '1',
    },
  ];

  return (
    <Box width={'100%'} height={'100%'} display={'flex'} justifyContent={'center'} minHeight={'100dvh'}>
      <Box
        sx={{
          marginTop: '40px',
          maxWidth: '728px',
          width: '100%',
        }}>
        <Typography
          textAlign={'center'}
          color={'white'}
          fontWeight={700}
          fontSize={'32px'}
          variant='h5'
          paddingBottom={3}>
          {tab ? 'CORE SALE PROGRAM DETAILS' : 'EDIT SALE PROGRAM'}
        </Typography>
        {isLoading ? (
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
            }}>
            <CircularProgress />
          </Box>
        ) : null}
        <BasicTabs
          onChange={tab => setTab(tab)}
          defaultValue='0'
          options={TABS_DATA}
          tabsProps={{
            sx: {
              '& .MuiTabs-indicator': {
                backgroundColor: 'transparent',
              },
              '& .MuiButtonBase-root': {
                color: '#ffffff',
                padding: '8px 16px',
                borderRadius: '4px',
                height: '36px',
                minHeight: '0px',
              },
              '& .MuiButtonBase-root.Mui-selected': {
                backgroundColor: '#2B3A7E',
              },
              borderRadius: '8px',
              border: `1px solid ${alpha('rgba(255, 255, 255)', 0.15)}`,
              backgroundColor: 'transparent',
              width: 'fit-content',
              padding: '8px',
            },
          }}
          tabProps={{
            sx: {
              '& button': {
                textTransform: 'capitalize',
              },
            },
          }}
          tabPanelSx={{
            borderRadius: '8px 16px',
            padding: '24px 0 0 0',
          }}
          renderContentTab={(opt: TabItem) => opt?.content}
        />
      </Box>
    </Box>
  );
};

export default DetailsNodeSale;
